import React, { Component } from 'react';

import SectionList from './Section/SectionList';
import SectionCorner from './Section/SectionCorner';
import SectionBar from './Section/SectionBar';

class SectionRecruit extends Component {

  render() {

    const { $$data, barOffset, horizontalOffset, width } = this.props;

    const align = 'right';

    const barColor = '#e24b4b';

    const listProps = {id: 'entreprise', data: $$data, barOffset, align, className: 'SectionCompany', title: 'Côté Entreprise', titleIcon: 'company', titleColor: '#6b6b6b', titleSize: width};
    return (
      <SectionList header={<div className="header">
        <SectionCorner length={50} style={{marginLeft: barOffset*-1}} corner={'br'} color={barColor} />
        <SectionBar length={Math.round(barOffset/2*3)} style={{top: 48, marginLeft: ((barOffset-horizontalOffset)*-1)}} color={barColor} direction={'horizontal'}/>
        <SectionCorner length={50} style={{top: 58, marginLeft: ((barOffset-58))}} corner={'tr'} color={barColor}/>
      </div>
    } barColor={barColor} style={this.props.style || {}} {...listProps}  />
  );
}
}

export default SectionRecruit;



// WEBPACK FOOTER //
// ./src/components/Home/SectionCompany.jsx